import React from 'react'
import PropTypes from 'prop-types'
import DisImage from '../../components/cms/image'

/**
 * Image component for media module that renders an image cropped to the module frame.
 *
 * @param {Object} props - Component props
 * @param {Object} props.asset - Image asset object containing src and metadata
 * @param {string} props.asset.src - Image source URL
 * @param {string} [props.asset.ariaLabel] - ARIA label for accessibility
 * @param {string} [props.asset.alt] - Alt text for the image
 * @returns {JSX.Element} Responsive DisImage cropped to the module frame
 */
const Image = ({asset}) => {
    const {src, ariaLabel, alt} = asset

    return (
        <DisImage
            aria-label={ariaLabel}
            src={src}
            alt={alt}
            objectFit="cover"
            widths={{base: '100vw', xs: '100vw', s: '100vw'}}
        />
    )
}

Image.propTypes = {
    asset: PropTypes.shape({
        // Image source URL selected for the current viewport
        src: PropTypes.string.isRequired,
        ariaLabel: PropTypes.string,
        alt: PropTypes.string
    }).isRequired
}

export default Image
